/* eslint-disable max-len */
import {
  Box,
  Button,
  Divider,
  Grid,
  Typography
} from '@mui/material';

import { Stack } from '@mui/system';
import { FormComunidadesRuraisAdicionar } from 'components/forms/adicionar_comunidade/form_comunidades_rurais_adicionar';
import { ContainerFormFormik } from 'components/shared/container_form_formik';
import InputComLabelFormik from 'components/shared/custom_input_label_formik';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useComunidadesRuraisTradicionaisStore from 'stores/forms/comunidades_rurais_tradicionais';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { FormularioComunidadesFormik } from 'interfaces/formularioComunidades.interface';
import { FormikProps } from 'formik';

interface Step1Props {
  onNext: () => void;
  formik: FormikProps<FormularioComunidadesFormik>;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const Step1: React.FC<Step1Props> = ({
  onNext,
  formik,
  open,
  setOpen
}) => {
  const [editValues, setEditValues] = useState<any>(null);
  const { comunidadesRuraisTradicionais } = useComunidadesRuraisTradicionaisStore();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const [isAssentamento, setIsAssentamento] = useState<boolean>(true);

  console.log(comunidadesRuraisTradicionais);

  const tiposAssentamento = [
    { value: 3, label: 'FEDERAIS – PA' },
    { value: 4, label: 'FEDERAIS CASULO/PCA (parceria entre INCRA e município)' },
    { value: 5, label: 'ESTADUAIS – PE' },
    { value: 6, label: 'PROJETOS DO TERRA BRASIL/ PROGRAMA NACIONAL DE CRÉDITO FUNDIÁRIO (PNCF)/ BANCO DA TERRA' },
  ];

  return (
    <ContainerFormFormik title='Cadastrar informações de Comunidades Rurais e Tradicionais' onSubmit={formik.handleSubmit}>

      <Grid item xs={12} mb={3}>
        <InputComLabelFormik
          label='anoReferencia'
          formik={formik}
          version='primary'
          labelTexto='Ano de Referência'
          type='text'
          disabled
        />
      </Grid>

      <FormComunidadesRuraisAdicionar formik={formik} open={open} setOpen={setOpen} editValues={editValues} setEditValues={setEditValues} />

      <Divider sx={{ my: 3 }} />

      <Box component='form'>

        <Typography variant='h6'>
          Assentamentos {formik.values.assentamentos.length}
        </Typography>

        <Grid item xs={12} mb={3}>


          {
            formik.values.assentamentos.map((assentamento: any, index: number) => (
              <Card key={index} sx={{ mb: 3, boxShadow: 3 }}>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant='h6'>Assentamento: {assentamento.nome_do_assentamento}</Typography>
                    <IconButton
                      onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                        setSelectedIndex(index);
                        setIsAssentamento(true);
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </Box>
                  <Typography variant='body1'>Tipo de assentamento: {tiposAssentamento.find(tipo => tipo.value === assentamento.tipo_de_assentamento)?.label}</Typography>
                  <Typography variant='body1'>Número do PA: MT{assentamento.codigo_do_pa}</Typography>
                  <Typography variant='body1'>Quantidade de familias: {assentamento.quantidade_de_familias}</Typography>
                  <Typography variant='body1'>Possui energia elétrica: {assentamento.possui_energia_eletrica ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Possui saneamento básico: {assentamento.possui_saneamento_basico ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Coleta de lixo: {assentamento.coleta_de_lixo ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Recebeu manutenção das estradas no último ano: {assentamento.recebeu_manutencao_das_estradas_no_ultimo_ano ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Possui escolas: {assentamento.possui_escolas ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Possui água para abastecimento doméstico: {assentamento.possui_agua_para_abastecimento_domestico ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Possui água para produção agropecuária: {assentamento.possui_agua_para_producao_agropecuaria ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Tem acesso à internet: {assentamento.tem_acesso_internet ? 'Sim' : 'Não'}</Typography>
                </CardContent>
              </Card>
            ))
          }

          <Typography variant='h6'>
            Comunidades Quilombolas: {formik.values.comunidades.length}
          </Typography>

          {
            formik.values.comunidades.map((comunidade: any, index: number) => (
              <Card key={index} sx={{ mb: 3, boxShadow: 3 }}>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant='h6'>Comunidade Quilombola: {comunidade.nome_do_assentamento}</Typography>
                    <IconButton
                      onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                        setSelectedIndex(index);
                        setIsAssentamento(false);
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </Box>
                  <Typography variant='body1'>Quantidade de familias: {comunidade.quantidade_de_familias}</Typography>
                  <Typography variant='body1'>Possui energia elétrica: {comunidade.possui_energia_eletrica ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Possui saneamento básico: {comunidade.possui_saneamento_basico ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Coleta de lixo: {comunidade.coleta_de_lixo ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Recebeu manutenção das estradas no último ano: {comunidade.recebeu_manutencao_das_estradas_no_ultimo_ano ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Possui escolas: {comunidade.possui_escolas ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Possui água para abastecimento doméstico: {comunidade.possui_agua_para_abastecimento_domestico ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Possui água para produção agropecuária: {comunidade.possui_agua_para_producao_agropecuaria ? 'Sim' : 'Não'}</Typography>
                  <Typography variant='body1'>Tem acesso à internet: {comunidade.tem_acesso_internet ? 'Sim' : 'Não'}</Typography>
                </CardContent>
              </Card>
            ))
          }

        </Grid>
      </Box>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={() => {
          setOpen(true);
          const item = isAssentamento ? formik.values.assentamentos[selectedIndex] : formik.values.comunidades[selectedIndex];
          item.step_atual = 1;
          setEditValues(item);
          setAnchorEl(null);
        }}>Editar</MenuItem>
        <MenuItem onClick={() => {
          if (isAssentamento) {
            formik.setFieldValue('assentamentos', formik.values.assentamentos.filter((_: any, i: number) => i !== selectedIndex));
          } else {
            formik.setFieldValue('comunidades', formik.values.comunidades.filter((_: any, i: number) => i !== selectedIndex));
          }
          setAnchorEl(null);
        }}>Excluir</MenuItem>
      </Menu>
    </ContainerFormFormik>

  );
};
